import React, {useRef, useEffect, useState, useMemo} from 'react';
import dayjs from 'dayjs';
import {isEqual} from 'lodash';

import Grid from '@mui/material/Grid';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';

import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {timestampToDate, getTimezoneNameString, isTimestamp} from 'ultra/helpers/date'

import {useConfigStore} from '../../../Stores/config';
import {useFormStore} from '../../../Stores/form';

import {ukLocale} from '../../../Helpers/locale';

import './index.scss'

export default function TimestampField(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [placeholder] = useState((field?.placeholder ? field?.placeholder : '') + (field?.required ? ' *' : ''))

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const {configs} = useConfigStore();

    const [timeZone, setTimeZone] = useState()
    useEffect(() => {
        const city = content._city || getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    const [value, setValue] = useState(null)

    const componentRef = useRef(null);

    const valueRef = useRef(null);
    const setValueRef = data => {
        valueRef.current = data;
    };

    const [ignoreControlCheck, setIgnoreControlCheck] = useState(false);

    const classNameWrap = useMemo(() => {
        let result = "TimestampFieldWrap";
        
        result += field?.options?.timePicker ? ' pseudoInput' : ''
        if (field?.options?.noPseudoInput) {
            result += ' noPseudoInput'
        }

        result += (!ignoreControlCheck && showErrorText) ? ' error' : ''
        return result;
    }, [field, showErrorText, ignoreControlCheck])

    const className = useMemo(() => {
        // console.log(ignoreControlCheck, showErrorText)
        let result = "TimestampField";
        result += isDisabled ? ' disabled' : ''
        result += (!ignoreControlCheck && showErrorText) ? ' error' : ''
        return result;
    }, [isDisabled, showErrorText, ignoreControlCheck])

    const hasInteractionRef = useRef(null);
    const setHasInteraction = data => {
        hasInteractionRef.current = data;
    };

    const handleClickOutside = (e) => {
        const clickOutside = componentRef.current && !componentRef.current.contains(e.target);

        if (!hasInteractionRef.current) {
            if (!clickOutside) setHasInteraction(true);
        }
        else if (clickOutside) {
            setIgnoreControlCheck(false);
            onBlur({target: {value: valueRef.current}});
        }
        else {
            setIgnoreControlCheck(true);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        let newValue
        if (content[field.id]) {
            newValue = dayjs(isTimestamp(content[field.id]) ? timestampToDate(content[field.id]) : new Date(content[field.id]))
        }
        else {
            newValue = null
        }

        setValueRef(newValue);

        // if (!isEqual(value, newValue)) 
            setValue(newValue);
    }, [content[field.id]])

    const onDateChange = (e) => { onChange({target: { value: e.valueOf() }}) }

    const onTimeChange = (e) => { onChange({target: { value: e.valueOf() }}) }

    return (<Grid className={className} key={field.id} item xs={12}>
        <div className={classNameWrap} ref={componentRef}>
            {field?.options?.timePicker && <div className='inputLabel'>{placeholder}</div>}

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk" localeText={ukLocale}>
                <DesktopDatePicker
                    closeOnSelect
                    className={`TimestampFieldDate ${className}`}
                    label={field?.options?.timePicker ? placeholder : "Дата"}
                    disabled={isDisabled}
                    value={value}
                    onChange={onDateChange}
                    onBlur={console.log}
                    timezone={timeZone}
                />
                
                {field?.options?.timePicker && 
                    <DesktopTimePicker
                        closeOnSelect = {false}
                        className={`TimestampFieldTime ${className}`}
                        label="Час"
                        disabled={isDisabled}
                        value={value}
                        views={['hours', 'minutes']}
                        onChange={onTimeChange}
                        onBlur={console.log}
                        timezone={timeZone}
                    />
                }
            </LocalizationProvider>

            {!field?.options?.timePicker && !ignoreControlCheck && showErrorText && <div className='fieldError'>
                {showErrorText}
            </div>}
        </div>

        {field?.options?.showTimezone && timeZone &&
            <div className='TimestampFieldLocale'>
                {getTimezoneNameString((value?.toDate() || new Date()), timeZone)}
            </div>
        }

        {field?.options?.timePicker && !ignoreControlCheck && showErrorText && <div className='fieldError'>
            {showErrorText}
        </div>}
    </Grid>)
}
